// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//IMG

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="bannerValuta" className="space-ptb bg-primary">
            <div className="container-fluid w-85">
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <h2>{t('homePage.sellBanner.title')}</h2>
                        <p className="mb-4 sub-title" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.subTitle') as string }} />
                        <p className="text-white" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
                        <p className="text-white" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para2') as string }} />
                        <p className="mb-4 text-white" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para3') as string }} />
                    </div>
                </div>
                <div className="col-img">
                    <img src="/assets/images/inHome/siena.jpg" alt="Siena" className="bg-white img-fluid" />
                    <Link className="btn btn-primary" to="/valutazione">
                        <span>{t('homePage.sellBanner.btnText')}</span>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default BannerVendi;